/* eslint-disable @typescript-eslint/naming-convention */
import apiServices from 'config/apiServiceApiGateway'

export type GetDirectPutawayParamsType = Partial<{
  search_task: string
  search_purchase_order: string
  search_asset: string
  statuses: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED'
  location_ids: number
  'pagination.page_index': number
  'pagination.page_size': number
}>

export type GetDirectPutawayResponseType = {
  data: {
    id: number
    task_number: string
    purchase_order_number: string
    inbound_date: number
    location_id: number
    location_name: string
    package_label: string
    status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED'
  }[]
  pagination: {
    page_index: number
    page_size: number
  }
}

export type GetDirectPutawayDetailResponseType = {
  data: {
    id: number
    task_number: string
    purchase_order_number: string
    staff_name: string
    location_id: number
    location_name: string
    status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED'
    activities: {
      activity_name: string
      start_date: string
      end_date: string
      duration: number
      created_by: string
    }[]
  }
}

export type GetDirectPutawayItemByTaskIdParamsType = Partial<{
  id: number
  search_product: string
  'pagination.page_index': number
  'pagination.page_size': number
}>

export type GetDirectPutawayItemByTaskIdResponseType = {
  data: {
    product_id: number
    product_name: string
    product_sku: string
    product_image: {
      url_medium: string
      url_small: string
      url_large: string
      sequence: number
    }
    qty: number
    base_uom: string
    carton_qty: number
    carton_uom: string
    from_rack_id: number
    from_rack_name: string
    to_rack_id: number
    to_rack_name: string
    staff_name: string
  }[]
  pagination: {
    page_index: number
    page_size: number
  }
}

export const getDirectPutawayAPI = (params?: GetDirectPutawayParamsType) =>
  apiServices.Get<GetDirectPutawayResponseType, true>({
    url: `/wims/internal/v1/putaway-tasks`,
    params,
  })

export const getDirectPutawayDetailAPI = (id: number) =>
  apiServices.Get<GetDirectPutawayDetailResponseType, true>({
    url: `/wims/internal/v1/putaway-tasks/${id}`,
  })

export const getDirectPutawayItemByTaskIdAPI = (
  id: number,
  params?: GetDirectPutawayItemByTaskIdParamsType,
) =>
  apiServices.Get<GetDirectPutawayItemByTaskIdResponseType, true>({
    url: `/wims/internal/v2/putaway-tasks/${id}/items`,
    params,
  })

export const deleteDirectPutawayUnassignStaffAPI = (id: number) =>
  apiServices.Delete<{ message: string }, true>({
    url: `/wims/internal/v1/putaway-tasks/${id}/assignment`,
  })
